import { useSearchParams } from 'react-router-dom';

export function useDay() {
  const [searchParams, setSearchParams] = useSearchParams();

  const viewAllDays = () => {
    // @ts-ignore
    const { day: _day, stop: _stop, ...newSearchParams } = Object.fromEntries(searchParams);
    setSearchParams(newSearchParams);
  };

  const viewDay = (/** @type {string} */ dayNumber) => {
    setSearchParams({ ...Object.fromEntries(searchParams), day: dayNumber });
  };

  const getCurrentDayNumber = () => {
    return searchParams.get('day');
  };

  return {
    viewAllDays,
    viewDay,
    getCurrentDayNumber,
  };
}
